import React, { useEffect, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import TableAction from "../../components/TableAction";
import { message, Modal, Select, Table } from "antd";
import { Region, Zone } from "../../components/modals/CreateWarehouseModal";
import {
  useAssignUserToWarehouse,
  useCountryStruct,
  useGetWorkLocations,
} from "../../api/admin";
import { useUsersList } from "../../api/users";

function WorkLocationPage() {
  const {
    data: allUsers,
    isLoading: allUsersIsLoading,
    refetch: refetchAll,
  } = useUsersList(1, 10);
  const [searchText, setSearchText] = useState("");
  const [tableData, setTableData] = useState([]);
  const [vces, setVces] = useState([]);

  const [openWorkLocation, setOpenWorkLocation] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState();
  const { data: workLocations, refetch, isLoading } = useGetWorkLocations();

  const [countryId, setCountryId] = useState(-1);
  const [selectedRegionId, setSelectedRegionId] = useState<
    number | undefined
  >();
  const [selectedZoneId, setSelectedZoneId] = useState<number | undefined>();

  const [zones, setZones] = useState<Zone[] | undefined>();
  const [regions, setRegions] = useState<Region[] | undefined>();
  const { mutateAsync: assignUser, isPending: assigningUser } =
    useAssignUserToWarehouse();
  const { data } = useCountryStruct();

  useEffect(() => {
    refetch();
    refetchAll();
  }, []);

  useEffect(() => {
    if (allUsers) {
      const _vces = allUsers.data.data
        .filter((item: any) => item.role === "MOB_ROLE_BUYER_AGENT")
        .map((item: any) => {
          return {
            id: item.id,
            fullName: item.fullName + " @" + item.username,
          };
        });

      setVces(_vces);
    }
  }, [allUsers]);

  useEffect(() => {
    if (data && data.data) {
      setCountryId(data.data.data.countryId);

      const _regions = data.data.data.regionDtoList.map((item: any) => {
        return { regionId: item.regionId, regionName: item.regionName };
      });

      setRegions(_regions);
    }
  }, [data]);

  useEffect(() => {
    if (data && data.data && selectedRegionId) {
      const region = data.data.data.regionDtoList.find(
        (r: any) => r.regionId === selectedRegionId
      );

      if (region) {
        const _zones = region.zoneDtos.map((item: any) => {
          return { zoneId: item.zoneId, zoneName: item.zoneName };
        });

        setZones(_zones);
      }
    }
  }, [selectedRegionId]);

  useEffect(() => {
    //     if (searchText) {
    //       const _data = allUsers.data.data.filter(
    //         (item: any) =>
    //           item.fullName?.toLowerCase().includes(searchText.toLowerCase()) ||
    //           item.email?.toLowerCase().includes(searchText.toLowerCase()) ||
    //           item.phoneNo?.toLowerCase().includes(searchText.toLowerCase()) ||
    //           item.role?.toLowerCase().includes(searchText.toLowerCase())
    //       );
    //       const data = filterUsersByStatus(_data);
    //       setTableData(data);
    //     } else {
    //       const data = filterUsersByStatus(allUsers.data.data);
    //       setTableData(data);
    //     }
    //   } else if (
    //     myUsers &&
    //     myUsers.data &&
    //     !!myUsers &&
    //     !!myUsers.data &&
    //     !!myUsers.data.data
    //   ) {
    //     if (searchText) {
    //       const _data = myUsers.data.data.filter(
    //         (item: any) =>
    //           item.fullName?.toLowerCase().includes(searchText.toLowerCase()) ||
    //           item.email?.toLowerCase().includes(searchText.toLowerCase()) ||
    //           item.phoneNo?.toLowerCase().includes(searchText.toLowerCase()) ||
    //           item.username?.toLowerCase().includes(searchText.toLowerCase()) ||
    //           item.role?.toLowerCase().includes(searchText.toLowerCase())
    //       );
    //       const data = filterUsersByStatus(_data);
    //       setTableData(data);
    //     } else {
    //       const data = filterUsersByStatus(myUsers?.data.data);
    //       setTableData(data);
    //     }
  }, [searchText, workLocations]);

  const addWorkLocation = async () => {
    if (selectedUserId && selectedRegionId && selectedZoneId) {
      try {
        const _result = await assignUser({
          userId: Number(selectedUserId),
          regionId: Number(selectedRegionId),
          zoneId: Number(selectedZoneId),
        });
        message.success("Work location assigned successfully.");
      } catch (err: any) {
        message.error("Operation failed");
      } finally {
        setOpenWorkLocation(false);
      }
    }
  };

  const columns = [
    { dataIndex: "fullName", title: "Full name" },
    { dataIndex: "phoneNo", title: "Phone No." },
    { dataIndex: "email", title: "Email" },
    { dataIndex: "region", title: "Region" },
    { dataIndex: "zone", title: "Zone" },
    { dataIndex: "status", title: "Status" },
  ];

  return (
    <div className="rounded-xl md:px-[50px] md:mt-[25px] md:pt-[22px] bg-transparent md:bg-white">
      <Modal
        destroyOnClose={true}
        title={<div style={{ color: "black" }}>Add work location</div>}
        open={openWorkLocation}
        centered
        onOk={addWorkLocation}
        okButtonProps={{
          disabled: assigningUser,
          loading: assigningUser,
        }}
        onCancel={() => {
          setOpenWorkLocation(false);
        }}
        closable
        style={{ color: "black" }}
      >
        <Select
          className="mb-3"
          value={selectedUserId}
          placeholder="Select user"
          style={{ width: "100%" }}
          onChange={(val: any) => setSelectedUserId(val)}
          options={vces?.map((item: any) => {
            return { label: item.fullName, value: item.id };
          })}
        />

        <Select
          className="mb-3"
          value={selectedRegionId}
          placeholder="Select region"
          style={{ width: "100%" }}
          onChange={(val: any) => setSelectedRegionId(val)}
          options={regions?.map((item: any) => {
            return { label: item.regionName, value: item.regionId };
          })}
        />

        <Select
          value={selectedZoneId}
          placeholder="Select zone"
          style={{ width: "100%" }}
          onChange={(val: any) => setSelectedZoneId(val)}
          options={zones?.map((_zone: any) => {
            return { label: _zone.zoneName, value: _zone.zoneId };
          })}
        />
      </Modal>
      <div className="hidden md:flex justify-center h-20 bg-[#EEF3F8] rounded-xl mb-3">
        <TableAction
          setSearchText={setSearchText}
          onCreateNew={() => setOpenWorkLocation(true)}
        />
      </div>
      <Table
        style={{ cursor: "pointer", marginTop: 25 }}
        dataSource={workLocations?.data.data}
        columns={columns}
        loading={isLoading}
      />
    </div>
  );
}

export default WithAuth(WorkLocationPage);
